import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useHeaderSlot, HEADER_SEARCH_SLOT_ID } from '../contexts/HeaderSlotContext';

const HeaderSearchPortal = ({ children }) => {
  const { setDesktopSearchVisible } = useHeaderSlot();
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (typeof document === 'undefined') {
      return () => {};
    }

    let frame;

    const findTarget = () => {
      const el = document.getElementById(HEADER_SEARCH_SLOT_ID);
      if (el) {
        setTarget(el);
      } else {
        frame = requestAnimationFrame(findTarget);
      }
    };

    setDesktopSearchVisible(true);
    findTarget();

    return () => {
      if (frame) {
        cancelAnimationFrame(frame);
      }
      setDesktopSearchVisible(false);
      setTarget(null);
    };
  }, [setDesktopSearchVisible]);

  if (!target) return null;

  return createPortal(children, target);
};

export default HeaderSearchPortal;

